var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
import { EGenericStatusType } from "@frameworks/shared-library/components/GenericStatus/GenericStatus";
import { EValueType, } from "@frameworks/shared-library/components/GenericDetails/GenericDetails";
import { ETimelineState, } from "@frameworks/shared-library/components/GenericTimeline/GenericTimeline";
import moment from "moment";
import { EKebebMenuItems } from "@frameworks/salesjourney/components/Features/ActivityBook/RM_Orderbook/ManagePortfolio/MutualFundOrders/MutualFundOrderbookContext";
// *******************************************
// *                 Enums                   *
// *******************************************
export var EOrderBookStatus;
(function (EOrderBookStatus) {
    // Authentication Pending is masked as Consent pending
    // Order Accepted
    // Payment Processed is masked as Order in progress
    // Consent Approved is nothing but Payment pending
    EOrderBookStatus["CONSENT_PENDING"] = "consent pending";
    EOrderBookStatus["CONSENT_REJECTED"] = "consent rejected";
    EOrderBookStatus["PAYMENT_PENDING"] = "payment pending";
    EOrderBookStatus["PAYMENT_FAILED"] = "payment failed";
    EOrderBookStatus["ORDER_REJECTED"] = "order rejected";
    EOrderBookStatus["ORDER_CANCELLED"] = "cancelled";
    EOrderBookStatus["ORDER_INPROGRESS"] = "order in progress";
    EOrderBookStatus["ORDER_COMPLETED"] = "completed";
    EOrderBookStatus["ACTIVE"] = "active";
    EOrderBookStatus["PAUSE"] = "paused";
    EOrderBookStatus["ORDER_ACCEPTED"] = "order accepted";
})(EOrderBookStatus || (EOrderBookStatus = {}));
export var ETransactionType;
(function (ETransactionType) {
    ETransactionType["STP"] = "STP";
    ETransactionType["SWP"] = "SWP";
    ETransactionType["SWITCH"] = "Switch";
    ETransactionType["SIP"] = "SIP";
    ETransactionType["REDEEM"] = "Redeem";
    ETransactionType["LUMPSUM"] = "Lumpsum";
    ETransactionType["SIP_INSTALLMENT"] = "SIP Installment";
    ETransactionType["SIP_CANCEL"] = "SIP Cancel";
    ETransactionType["SIP_PAUSE"] = "SIP Pause";
    ETransactionType["SIP_MODIFY"] = "SIP Modify";
    ETransactionType["SIP_RESUME"] = "SIP Resume";
    ETransactionType["SWP_CANCEL"] = "SWP Cancel";
    ETransactionType["STP_CANCEL"] = "STP Cancel";
    ETransactionType["SWP_INSTALLMENT"] = "SWP Installment";
    ETransactionType["STP_INSTALLMENT"] = "STP Installment";
})(ETransactionType || (ETransactionType = {}));
export var EMandateStatuses;
(function (EMandateStatuses) {
    EMandateStatuses["ACTIVE"] = "Active";
    EMandateStatuses["DOC_UPLOAD_PENDING"] = "Doc Upload Pending";
    // VERIFICATION_IN_PROGRESS = "Verification In Progress",
    EMandateStatuses["PROCESSING"] = "Processing";
    EMandateStatuses["INACTIVE"] = "Inactive";
    EMandateStatuses["REGISTRATION_FAILED"] = "Registration Failed";
    EMandateStatuses["REGISTRATION_PENDING"] = "Registration pending";
    EMandateStatuses["WAITING_FOR_CLIENT_AUTHENTICATION"] = "WAITING FOR CLIENT AUTHENTICATION";
    // add for SCAN IMAGE NOT UPLOADED
    EMandateStatuses["SCAN_IMAGE_NOT_UPLOADED"] = "SCAN IMAGE NOT UPLOADED";
    EMandateStatuses["APPROVED"] = "APPROVED";
    EMandateStatuses["DOC_NOT_UPLOADED"] = "Document not uploaded";
})(EMandateStatuses || (EMandateStatuses = {}));
export var EMandateTimelineStatuses;
(function (EMandateTimelineStatuses) {
    EMandateTimelineStatuses["VERIFICATION_COMPLETED"] = "Verification Completed";
    EMandateTimelineStatuses["REGISTRATION_COMPLETED"] = "Registration Completed";
    EMandateTimelineStatuses["DOCUMENT_UPLOADED"] = "Document uploaded";
})(EMandateTimelineStatuses || (EMandateTimelineStatuses = {}));
// Component to display on sidebar
export var EOrderbookSidebarComponents;
(function (EOrderbookSidebarComponents) {
    EOrderbookSidebarComponents["STATUS_BOX"] = "statusBox";
    EOrderbookSidebarComponents["SCHEME_DETAILS"] = "schemeDetails";
    EOrderbookSidebarComponents["TRANSACTION_DETAILS"] = "transactionDetails";
    EOrderbookSidebarComponents["ORDER_TIMELINE_DETAILS"] = "orderTimelineDetails";
    EOrderbookSidebarComponents["PAST_INSTALLMENTS"] = "pastInstallments";
})(EOrderbookSidebarComponents || (EOrderbookSidebarComponents = {}));
// Table from which sidebar is opened
export var ESidebarActioningFrom;
(function (ESidebarActioningFrom) {
    ESidebarActioningFrom["ALL_TRANSACTIONS_TABLE"] = "allTransactions";
    ESidebarActioningFrom["SIP_TABLE"] = "SIPTable";
    ESidebarActioningFrom["STP_TABLE"] = "STPTable";
    ESidebarActioningFrom["SWP_TABLE"] = "SWPTable";
})(ESidebarActioningFrom || (ESidebarActioningFrom = {}));
export var EInvestmentActionCodes;
(function (EInvestmentActionCodes) {
    EInvestmentActionCodes["NEW_PURCHASE"] = "1";
    EInvestmentActionCodes["PAUSE"] = "2";
    EInvestmentActionCodes["MODIFY"] = "3";
    EInvestmentActionCodes["CANCEL"] = "4";
})(EInvestmentActionCodes || (EInvestmentActionCodes = {}));
// *******************************************
// *              Constants                  *
// *******************************************
export var displayTransactionTypeText = (_a = {},
    _a[ETransactionType.STP] = "STP",
    _a[ETransactionType.SWP] = "SWP",
    _a[ETransactionType.SWITCH] = "Switch",
    _a[ETransactionType.SIP] = "SIP",
    _a[ETransactionType.SIP_INSTALLMENT] = "SIP Installment",
    _a[ETransactionType.SIP_CANCEL] = "SIP Cancel",
    _a[ETransactionType.SIP_MODIFY] = "SIP Modify",
    _a[ETransactionType.SIP_PAUSE] = "SIP Pause",
    _a[ETransactionType.REDEEM] = "Redeem",
    _a[ETransactionType.LUMPSUM] = "Lumpsum",
    _a[ETransactionType.SIP_RESUME] = "SIP Resume",
    _a[ETransactionType.STP_CANCEL] = "STP Cancel",
    _a[ETransactionType.SWP_CANCEL] = "SWP Cancel",
    _a[ETransactionType.SWP_INSTALLMENT] = "SWP Installment",
    _a[ETransactionType.STP_INSTALLMENT] = "STP Installment",
    _a);
export var orderBookStatusType = (_b = {},
    _b[EOrderBookStatus.CONSENT_PENDING] = EGenericStatusType.WARNING,
    _b[EOrderBookStatus.CONSENT_REJECTED] = EGenericStatusType.DANGER,
    _b[EOrderBookStatus.PAYMENT_PENDING] = EGenericStatusType.WARNING,
    _b[EOrderBookStatus.PAYMENT_FAILED] = EGenericStatusType.DANGER,
    _b[EOrderBookStatus.ORDER_REJECTED] = EGenericStatusType.DANGER,
    _b[EOrderBookStatus.ORDER_CANCELLED] = EGenericStatusType.DANGER,
    _b[EOrderBookStatus.ORDER_INPROGRESS] = EGenericStatusType.WARNING,
    _b[EOrderBookStatus.ORDER_COMPLETED] = EGenericStatusType.SUCCESS,
    _b[EOrderBookStatus.ACTIVE] = EGenericStatusType.SUCCESS,
    _b[EOrderBookStatus.ORDER_ACCEPTED] = EGenericStatusType.WARNING,
    _b[EOrderBookStatus.PAUSE] = EGenericStatusType.PENDING,
    _b[EMandateStatuses.ACTIVE] = EGenericStatusType.SUCCESS,
    _b[EMandateStatuses.DOC_UPLOAD_PENDING] = EGenericStatusType.WARNING,
    _b[EMandateStatuses.PROCESSING] = EGenericStatusType.WARNING,
    _b[EMandateStatuses.INACTIVE] = EGenericStatusType.DANGER,
    _b[EMandateStatuses.REGISTRATION_FAILED] = EGenericStatusType.DANGER,
    _b[EMandateStatuses.REGISTRATION_PENDING] = EGenericStatusType.WARNING,
    _b[EMandateStatuses.APPROVED] = EGenericStatusType.SUCCESS,
    _b);
// *******************************************
// *           Public methods                *
// *******************************************
export var getStatusDescription = function (trxType, status, clientName) {
    var _a;
    var sipStatusDescription = {
        cancelled: "SIP mutual fund",
        completed: "You can view your completed orders under SIPs tab",
    };
    var stpStatusDescription = {
        cancelled: "STP",
        completed: "You can track your order under STPs tab",
    };
    var swpStatusDescription = {
        cancelled: "SWP",
        completed: "You can track your order under SWPs tab",
    };
    var statusDescriptionHints = (_a = {},
        _a[ETransactionType.LUMPSUM] = {
            cancelled: "lumpsum mutual fund",
            completed: "You can view your completed orders under My Portfolio.",
        },
        _a[ETransactionType.SIP] = sipStatusDescription,
        _a[ETransactionType.SIP_CANCEL] = sipStatusDescription,
        _a[ETransactionType.SIP_INSTALLMENT] = sipStatusDescription,
        _a[ETransactionType.SIP_MODIFY] = sipStatusDescription,
        _a[ETransactionType.SIP_PAUSE] = sipStatusDescription,
        _a[ETransactionType.SIP_RESUME] = sipStatusDescription,
        _a[ETransactionType.REDEEM] = {
            cancelled: "redemption",
            completed: "The money has been credited to your client\u2019s bank account.",
        },
        _a[ETransactionType.SWITCH] = {
            cancelled: "Switch",
            completed: "Your switch to the new fund scheme is complete. ",
        },
        _a[ETransactionType.STP] = stpStatusDescription,
        _a[ETransactionType.STP_CANCEL] = stpStatusDescription,
        _a[ETransactionType.STP_INSTALLMENT] = stpStatusDescription,
        _a[ETransactionType.SWP_CANCEL] = swpStatusDescription,
        _a[ETransactionType.SWP] = swpStatusDescription,
        _a[ETransactionType.SWP_INSTALLMENT] = swpStatusDescription,
        _a);
    switch (status) {
        case EOrderBookStatus.CONSENT_PENDING:
            return "The order is awaiting ".concat(clientName, "'s approval.");
        case EOrderBookStatus.CONSENT_REJECTED:
            return "This order was rejected by the client ".concat(clientName);
        case EOrderBookStatus.PAYMENT_PENDING:
            return "Complete payment to proceed with the transaction";
        case EOrderBookStatus.PAYMENT_FAILED:
            return "The transaction timed out. Please retry.";
        case EOrderBookStatus.ORDER_REJECTED:
            return "Your order got rejected by Exchange ";
        case EOrderBookStatus.ORDER_CANCELLED:
            return "Your client, ".concat(clientName, " has cancelled the ").concat(statusDescriptionHints[trxType].cancelled, " order. Explore new investment options.");
        case EOrderBookStatus.ORDER_INPROGRESS:
        case EOrderBookStatus.ORDER_ACCEPTED:
            return "Your order is being processed by Exchange";
        case EOrderBookStatus.ORDER_COMPLETED:
            return "".concat(statusDescriptionHints[trxType].completed);
        default:
            return undefined;
    }
};
export var getNextTransactionText = function (trxType, status) {
    if (trxType === ETransactionType.SIP && status === EOrderBookStatus.ACTIVE) {
        return "Next Installment: ";
    }
    else if (trxType === ETransactionType.SIP &&
        status === EOrderBookStatus.PAUSE) {
        return "Till";
    }
    else if (trxType === ETransactionType.STP &&
        status === EOrderBookStatus.ACTIVE) {
        return "Next Transfer: ";
    }
    else if (trxType === ETransactionType.SWP &&
        status === EOrderBookStatus.ACTIVE) {
        return "Next Withdrawal: ";
    }
    else {
        return "";
    }
};
export var getSchemeDetails = function (rowDetails, actioningFrom) {
    var paymentMethod = generatePaymentMethod(rowDetails, actioningFrom);
    switch (rowDetails.displayTransactionType) {
        case ETransactionType.SIP:
        case ETransactionType.SIP_INSTALLMENT:
        case ETransactionType.SIP_CANCEL:
        case ETransactionType.SIP_MODIFY:
        case ETransactionType.SIP_PAUSE:
        case ETransactionType.SIP_RESUME:
            return __spreadArray(__spreadArray(__spreadArray(__spreadArray([
                {
                    label: "".concat(rowDetails.displayStatus === EOrderBookStatus.ACTIVE
                        ? "Start Date"
                        : "End Date"),
                    value: rowDetails.displayStatus === EOrderBookStatus.ACTIVE
                        ? moment((rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.startDate) || (rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.displayTransactionTime)).format("DD MMM YY")
                        : moment(rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.endDate).format("DD MMM YY") || "-",
                    valueType: EValueType.NUMBER,
                }
            ], __read((rowDetails.displayTransactionType !==
                ETransactionType.SIP_INSTALLMENT
                ? [
                    {
                        label: "Installments",
                        value: (rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.totalNoOfInstallments) || "-",
                        valueType: EValueType.NUMBER,
                    },
                ]
                : [
                    {
                        label: "Installment No",
                        value: (rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.installmentNumber) || "-",
                        valueType: EValueType.NUMBER,
                    },
                ])), false), [
                {
                    label: "Total Investment",
                    value: "".concat(rowDetails.totalInstallmentAmtPaid
                        ? "\u20B9".concat(rowDetails.totalInstallmentAmtPaid)
                        : "-"),
                    valueType: EValueType.NUMBER,
                },
                {
                    label: "Action",
                    value: displayTransactionTypeText[rowDetails.displayTransactionType] ||
                        "-",
                    valueType: EValueType.TEXT,
                },
                {
                    label: "Mandate Type",
                    value: "".concat(rowDetails.displayMandateType
                        ? "".concat(rowDetails.displayMandateType, "-Mandate")
                        : "-"),
                    valueType: EValueType.TEXT,
                },
                {
                    label: "Investment Type",
                    value: rowDetails.investmentType || "-",
                    valueType: EValueType.TEXT,
                }
            ], false), __read(((rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.displayTransactionId)
                ? [
                    {
                        label: "Order ID",
                        value: rowDetails.displayTransactionId,
                        valueType: EValueType.NUMBER,
                    },
                ]
                : [])), false), [
                {
                    label: "Mandate ID",
                    value: rowDetails.mandateId || "-",
                    valueType: EValueType.NUMBER,
                },
                {
                    label: "Payment method",
                    value: paymentMethod || "-",
                    valueType: EValueType.TEXT,
                },
            ], false);
        case ETransactionType.STP:
        case ETransactionType.STP_CANCEL:
        case ETransactionType.STP_INSTALLMENT:
            return __spreadArray([
                {
                    label: "".concat(rowDetails.displayStatus === EOrderBookStatus.ORDER_COMPLETED
                        ? "End Date"
                        : "Start Date"),
                    value: rowDetails.displayStatus === EOrderBookStatus.ORDER_COMPLETED
                        ? moment(rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.endDate).format("DD MMM YY") || "-"
                        : moment((rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.startDate) || (rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.displayTransactionTime)).format("DD MMM YY") || "-",
                    valueType: EValueType.NUMBER,
                },
                {
                    label: "Transfers",
                    value: "".concat(rowDetails.totalInstallmentsCompleted, "/").concat(rowDetails.totalNoOfInstallments) ||
                        "-",
                    valueType: EValueType.NUMBER,
                },
                {
                    label: "Total Transfer",
                    value: "".concat(rowDetails.totalInstallmentAmtPaid
                        ? "\u20B9".concat(rowDetails.totalInstallmentAmtPaid)
                        : "-"),
                    valueType: EValueType.NUMBER,
                },
                { label: "Action", value: "STP", valueType: EValueType.TEXT },
                {
                    label: "Investment Type",
                    value: rowDetails.investmentType || "-",
                    valueType: EValueType.TEXT,
                }
            ], __read((rowDetails.displayTransactionType ===
                ETransactionType.STP_INSTALLMENT
                ? [
                    {
                        label: "Instalment No.",
                        value: rowDetails.installmentNumber || "-",
                        valueType: EValueType.NUMBER,
                    },
                ]
                : [])), false);
        case ETransactionType.SWP:
        case ETransactionType.SWP_INSTALLMENT:
            if (rowDetails.displayStatus !== EOrderBookStatus.ORDER_CANCELLED) {
                return __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
                    {
                        label: "Order ID",
                        value: rowDetails.displayTransactionId || "-",
                        valueType: EValueType.NUMBER,
                    }
                ], __read((rowDetails.displayTransactionType ===
                    ETransactionType.SWP_INSTALLMENT
                    ? [
                        {
                            label: "Withdrawal Date",
                            value: rowDetails.displayTransactionTime.split(",")[0] || "-",
                            valueType: EValueType.NUMBER,
                        },
                    ]
                    : [
                        {
                            label: "Start Date",
                            value: rowDetails.firstInstallmentDate ||
                                (rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.startDate) ||
                                "-",
                            valueType: EValueType.NUMBER,
                        },
                    ])), false), [
                    {
                        label: "Total Withdrawal",
                        value: "".concat(rowDetails.totalInstallmentAmtPaid
                            ? "\u20B9".concat(rowDetails.totalInstallmentAmtPaid)
                            : "-"),
                        valueType: EValueType.NUMBER,
                    }
                ], false), __read((rowDetails.displayTransactionType ===
                    ETransactionType.SWP_INSTALLMENT
                    ? [
                        {
                            label: "Instalment No.",
                            value: rowDetails.installmentNumber || "-",
                            valueType: EValueType.NUMBER,
                        },
                    ]
                    : [
                        {
                            label: "No of Instalments",
                            value: rowDetails.totalNoOfInstallments || "-",
                            valueType: EValueType.NUMBER,
                        },
                    ])), false), [
                    {
                        label: "Instalments Completed",
                        value: rowDetails.totalInstallmentsCompleted || "-",
                        valueType: EValueType.NUMBER,
                    },
                    {
                        label: "Withdrawal Date",
                        value: rowDetails.startDay || "-",
                        valueType: EValueType.NUMBER,
                    },
                    {
                        label: "Placed On",
                        value: moment(rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.displayCreatedTime).format("DD MMM YYYY, h:mm:ss A") || "-",
                        valueType: EValueType.NUMBER,
                    },
                    {
                        label: "Frequency",
                        value: rowDetails.dpFrequency || "-",
                        valueType: EValueType.TEXT,
                    },
                    {
                        label: "Registration ID",
                        value: (rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.registrationNumber) || "-",
                        valueType: EValueType.NUMBER,
                    },
                    {
                        label: "Transaction Mode",
                        value: (rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.investmentType) || "-",
                        valueType: EValueType.TEXT,
                    }
                ], false), __read((rowDetails.displayTransactionType === ETransactionType.SWP
                    ? [
                        {
                            label: "To Bank Account",
                            value: paymentMethod || "-",
                            valueType: EValueType.TEXT,
                        },
                    ]
                    : [])), false);
            }
            else {
                return [
                    {
                        label: "Start Date",
                        value: rowDetails.firstInstallmentDate || (rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.startDate) || "-",
                        valueType: EValueType.NUMBER,
                    },
                    {
                        label: "Withdrawals",
                        value: "".concat(rowDetails.totalInstallmentsCompleted).concat(rowDetails.totalNoOfInstallments
                            ? "/".concat(rowDetails.totalNoOfInstallments)
                            : "") || "-",
                        valueType: EValueType.NUMBER,
                    },
                    {
                        label: "Total Withdrawals",
                        value: "".concat(rowDetails.totalInstallmentAmtPaid
                            ? "\u20B9".concat(rowDetails.totalInstallmentAmtPaid)
                            : "-"),
                        valueType: EValueType.NUMBER,
                    },
                    { label: "Action", value: "SWP", valueType: EValueType.TEXT },
                    {
                        label: "Investment Type",
                        value: (rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.investmentType) || "-",
                        valueType: EValueType.TEXT,
                    },
                ];
            }
        case ETransactionType.SWP_CANCEL:
            return __spreadArray([
                {
                    label: "".concat(rowDetails.displayStatus === EOrderBookStatus.ORDER_COMPLETED
                        ? "End Date"
                        : "Start Date"),
                    value: rowDetails.displayTransactionTime || "-",
                    valueType: EValueType.NUMBER,
                },
                {
                    label: "Withdrawals",
                    value: "".concat(rowDetails.totalInstallmentsCompleted, "/").concat(rowDetails.totalNoOfInstallments) ||
                        "-",
                    valueType: EValueType.NUMBER,
                },
                {
                    label: "Total Withdrawal",
                    value: "".concat(rowDetails.totalInstallmentAmtPaid
                        ? "\u20B9".concat(rowDetails.totalInstallmentAmtPaid)
                        : "-"),
                    valueType: EValueType.NUMBER,
                },
                { label: "Action", value: "SWP", valueType: EValueType.TEXT }
            ], __read((rowDetails.displayStatus === EOrderBookStatus.ACTIVE
                ? [
                    {
                        label: "To Bank Account",
                        value: paymentMethod || "-",
                        valueType: EValueType.TEXT,
                    },
                ]
                : [
                    {
                        label: "Investment Type",
                        value: rowDetails.investmentType || "-",
                        valueType: EValueType.TEXT,
                    },
                ])), false);
        default:
            return null;
    }
};
export var getTransactionDetailsList = function (rowDetails, actioningFrom, UPIIcon) {
    var _a, _b, _c, _d;
    var updatedPlacedOnTime = moment(rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.displayCreatedTime).format("DD MMM YYYY, h:mm:ss A");
    var orderIdPlacedOn = [
        {
            label: "Order ID",
            value: (rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.displayTransactionId) || "-",
            valueType: EValueType.TEXT,
            copyValue: Boolean(rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.displayTransactionId),
        },
        {
            label: "Placed on",
            value: updatedPlacedOnTime || "-",
            valueType: EValueType.TEXT,
        },
    ];
    var amount = [
        {
            label: "Amount",
            value: (rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.amount) || "-",
            valueType: EValueType.CURRENCY,
            labelSuffix: displayTransactionTypeText[rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.displayTransactionType],
        },
    ];
    var txnTypeFrequencyAndDay = function (txnType) {
        if (txnType === void 0) { txnType = ETransactionType.SIP; }
        return [
            {
                label: "".concat(txnType, " Frequency"),
                value: (rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.dpFrequency) || "-",
                valueType: EValueType.TEXT,
            },
            {
                label: "".concat(txnType, " Day"),
                value: (rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.displayStartDay) || "-",
                valueType: EValueType.TEXT,
            },
        ];
    };
    var unitsAndNav = [
        {
            label: rowDetails.displayStatus === EOrderBookStatus.ORDER_COMPLETED
                ? "Units/ Nav"
                : "Units/ Current Nav",
            value: generateUnitsAndNav(rowDetails.amount, rowDetails.transactionNav
                ? rowDetails.transactionNav
                : (_a = rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.scheme) === null || _a === void 0 ? void 0 : _a.nav),
            valueType: EValueType.NUMBER,
        },
    ];
    var navDate = [
        {
            label: "Nav Date",
            value: rowDetails.displayTransactionTime || "-",
            valueType: EValueType.TEXT,
        },
    ];
    var toBankAccount = [
        {
            label: "To Bank Account",
            value: generatePaymentMethod(rowDetails, actioningFrom) || "-",
            valueType: EValueType.TEXT,
        },
    ];
    var fromFundName = [
        {
            label: "From Fund Name",
            value: (_b = rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.scheme) === null || _b === void 0 ? void 0 : _b.schemeName,
            valueType: EValueType.TEXT,
        },
    ];
    var toFundName = [
        {
            label: "To Fund Name",
            value: ((_c = rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.toScheme) === null || _c === void 0 ? void 0 : _c.schemeName) || "-",
            valueType: EValueType.TEXT,
        },
    ];
    var withdrawalTransferDate = [
        {
            label: [
                ETransactionType.SWP,
                ETransactionType.SWP_CANCEL,
                ETransactionType.SWP_INSTALLMENT,
            ].includes(rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.displayTransactionType)
                ? "Withdrawal Day"
                : [
                    ETransactionType.STP,
                    ETransactionType.STP_CANCEL,
                    ETransactionType.STP_INSTALLMENT,
                ].includes(rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.displayTransactionType)
                    ? "Transfer Date"
                    : undefined,
            value: (rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.displayStartDay) || "-",
            valueType: EValueType.TEXT,
        },
    ];
    var noOfInstallmentsTransfers = [
        {
            label: "No of Installments",
            value: rowDetails.totalNoOfInstallments || "-",
            valueType: EValueType.TEXT,
        },
    ];
    var navUnits = [
        {
            label: "Current Nav",
            value: ((_d = rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.toScheme) === null || _d === void 0 ? void 0 : _d.nav) || "-",
            valueType: EValueType.NUMBER,
        },
    ];
    switch (rowDetails === null || rowDetails === void 0 ? void 0 : rowDetails.displayTransactionType) {
        case ETransactionType.LUMPSUM:
            return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(amount), false), __read((rowDetails.displayStatus === EOrderBookStatus.ORDER_COMPLETED
                ? __spreadArray([], __read(navDate), false) : [])), false), __read(orderIdPlacedOn), false), __read(showPaymentMethodBasedOnOrderStatusAndScreen(rowDetails, actioningFrom, UPIIcon)), false);
        case ETransactionType.SIP:
        case ETransactionType.SIP_RESUME:
        case ETransactionType.SIP_PAUSE:
        case ETransactionType.SIP_CANCEL:
        case ETransactionType.SIP_INSTALLMENT:
        case ETransactionType.SIP_MODIFY:
            return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(amount), false), __read(txnTypeFrequencyAndDay()), false), __read(orderIdPlacedOn), false), __read(showPaymentMethodBasedOnOrderStatusAndScreen(rowDetails, actioningFrom, UPIIcon)), false);
        case ETransactionType.REDEEM:
            return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(amount), false), __read(unitsAndNav), false), __read(toBankAccount), false), __read(orderIdPlacedOn), false);
        case ETransactionType.SWITCH:
            return __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(amount), false), __read(fromFundName), false), __read(toFundName), false), __read(orderIdPlacedOn), false), __read(navUnits), false);
        case ETransactionType.STP:
        case ETransactionType.STP_INSTALLMENT:
            return __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(amount), false), __read(fromFundName), false), __read(toFundName), false), __read(noOfInstallmentsTransfers), false), __read(withdrawalTransferDate), false), __read(orderIdPlacedOn), false);
        case ETransactionType.SWP:
            return __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(amount), false), __read(fromFundName), false), __read(showPaymentMethodBasedOnOrderStatusAndScreen(rowDetails, actioningFrom)), false), __read(noOfInstallmentsTransfers), false), __read(withdrawalTransferDate), false), __read(orderIdPlacedOn), false);
        case ETransactionType.SWP_INSTALLMENT:
            return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(amount), false), __read(fromFundName), false), __read(toBankAccount), false), __read(withdrawalTransferDate), false);
        case ETransactionType.SWP_CANCEL:
            return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(amount), false), __read(txnTypeFrequencyAndDay(ETransactionType.SWP)), false), __read(orderIdPlacedOn), false), __read((rowDetails.displayStatus !== EOrderBookStatus.ORDER_COMPLETED &&
                rowDetails.displayStatus !== EOrderBookStatus.CONSENT_PENDING &&
                rowDetails.displayStatus !== EOrderBookStatus.ORDER_REJECTED
                ? showPaymentMethodBasedOnOrderStatusAndScreen(rowDetails, actioningFrom, UPIIcon)
                : [])), false);
        case ETransactionType.STP_CANCEL:
            return __spreadArray(__spreadArray(__spreadArray([], __read(amount), false), __read(txnTypeFrequencyAndDay(ETransactionType.STP)), false), __read(orderIdPlacedOn), false);
        default:
            return null;
    }
};
export var timelineStatusType = (_c = {
        "consent pending": ETimelineState.IN_PROGRESS,
        "consent approved": ETimelineState.COMPLETED,
        "consent rejected": ETimelineState.FAILED,
        "payment pending": ETimelineState.IN_PROGRESS,
        "payment failed": ETimelineState.FAILED,
        "payment processed": ETimelineState.COMPLETED,
        "order rejected": ETimelineState.FAILED,
        cancelled: ETimelineState.FAILED,
        "order accepted": ETimelineState.COMPLETED,
        "order in progress": ETimelineState.IN_PROGRESS,
        completed: ETimelineState.COMPLETED
    },
    _c[EMandateStatuses.REGISTRATION_FAILED] = ETimelineState.FAILED,
    _c[EMandateStatuses.REGISTRATION_PENDING] = ETimelineState.IN_PROGRESS,
    _c[EMandateStatuses.INACTIVE] = ETimelineState.FAILED,
    _c[EMandateStatuses.ACTIVE] = ETimelineState.COMPLETED,
    _c[EMandateStatuses.DOC_UPLOAD_PENDING] = ETimelineState.IN_PROGRESS,
    _c[EMandateStatuses.PROCESSING] = ETimelineState.IN_PROGRESS,
    _c[EMandateStatuses.DOC_NOT_UPLOADED] = ETimelineState.FAILED,
    _c[EMandateStatuses.APPROVED] = ETimelineState.COMPLETED,
    _c[EMandateStatuses.SCAN_IMAGE_NOT_UPLOADED] = ETimelineState.FAILED,
    _c[EMandateStatuses.WAITING_FOR_CLIENT_AUTHENTICATION] = ETimelineState.IN_PROGRESS,
    _c[EMandateTimelineStatuses.DOCUMENT_UPLOADED] = ETimelineState.COMPLETED,
    _c[EMandateTimelineStatuses.REGISTRATION_COMPLETED] = ETimelineState.COMPLETED,
    _c[EMandateTimelineStatuses.VERIFICATION_COMPLETED] = ETimelineState.COMPLETED,
    _c.Cancelled = ETimelineState.FAILED,
    _c);
export var getTimelineDetails = function (timelineDetails, txnStatus) {
    var details = [];
    timelineDetails.map(function (item, index) {
        var _a;
        if (item.status) {
            var timelineStatus = index === timelineDetails.length - 1
                ? timelineStatusType[item.status.toLowerCase()]
                : ETimelineState.COMPLETED;
            details.push({
                header: (_a = item.status) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.txnStatus,
                status: timelineStatus,
                description: timelineStatus === ETimelineState.IN_PROGRESS
                    ? "_"
                    : item === null || item === void 0 ? void 0 : item.dpStatusTime,
            });
        }
    });
    if (txnStatus === EOrderBookStatus.PAYMENT_PENDING ||
        txnStatus === EOrderBookStatus.PAYMENT_FAILED) {
        details = __spreadArray(__spreadArray([], __read(details), false), [
            {
                header: "Order Accepted",
                status: ETimelineState.UNREACHED,
                description: "_",
            },
            {
                header: "Order Completed",
                status: ETimelineState.UNREACHED,
                description: "_",
            },
        ], false);
    }
    return details;
};
var generatePaymentMethod = function (selectedRowDetails, actioningFrom) {
    /**  All transaction tab:Lumpsum/SIP orders, Display Transaction bank details when it is first order today
                             Display Mandate bank details when it is not a first order today (applicable for SIPs)
        Subsequent SIP tab:  Display Mandate details irrespective of whether it is first order today or paylater
    */
    if (actioningFrom === ESidebarActioningFrom.SIP_TABLE ||
        (actioningFrom === ESidebarActioningFrom.ALL_TRANSACTIONS_TABLE &&
            selectedRowDetails.displayTransactionType !== ETransactionType.LUMPSUM &&
            !(selectedRowDetails === null || selectedRowDetails === void 0 ? void 0 : selectedRowDetails.firstOrderToday))) {
        if (Boolean(selectedRowDetails === null || selectedRowDetails === void 0 ? void 0 : selectedRowDetails.bankName) &&
            Boolean(selectedRowDetails.accountNumber)) {
            return "".concat((selectedRowDetails === null || selectedRowDetails === void 0 ? void 0 : selectedRowDetails.mandateType)
                ? selectedRowDetails.mandateType + "-Mandate |"
                : "", " ").concat(selectedRowDetails === null || selectedRowDetails === void 0 ? void 0 : selectedRowDetails.bankName, " ****").concat(selectedRowDetails.accountNumber.slice(-4));
        }
    }
    if (Boolean(selectedRowDetails.clientBankName) &&
        Boolean(selectedRowDetails.clientBankAcNum)) {
        return "".concat(selectedRowDetails.paymentMethod
            ? selectedRowDetails.paymentMethod + "|"
            : "", " ").concat(selectedRowDetails.clientBankName, " ****").concat(selectedRowDetails.clientBankAcNum.slice(-4));
    }
    return;
};
var showPaymentMethodBasedOnOrderStatusAndScreen = function (selectedRowDetails, actioningFrom, UPIIcon) {
    var _a, _b;
    /**  All transaction tab: Display payment details when order reaches payment flow only; ie after crossing payment pending phase
         Subsequent SIP tab:  Display payment details always as payment details here are Mandate bank details which are selected at the time of placing order
    */
    var paymentDetails = generatePaymentMethod(selectedRowDetails, actioningFrom);
    if (actioningFrom === ESidebarActioningFrom.ALL_TRANSACTIONS_TABLE &&
        (selectedRowDetails.displayStatus === EOrderBookStatus.CONSENT_PENDING ||
            selectedRowDetails.displayStatus === EOrderBookStatus.CONSENT_REJECTED ||
            selectedRowDetails.displayStatus == EOrderBookStatus.PAYMENT_PENDING ||
            selectedRowDetails.displayTransactionType === ETransactionType.SIP_CANCEL))
        return [];
    var labelName = ((_b = (_a = selectedRowDetails.displayTransactionType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === null || _b === void 0 ? void 0 : _b.includes("SWP"))
        ? "To Bank Account"
        : "Payment method";
    return [
        {
            label: labelName,
            value: paymentDetails || "-",
            valueType: EValueType.TEXT,
            valueIcon: (paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.includes("UPI")) ? UPIIcon : undefined,
        },
    ];
};
var generateUnitsAndNav = function (amount, currentNav) {
    var amountNum = Number(amount);
    var currentNavNum = Number(currentNav);
    if (amountNum && currentNavNum) {
        var units = Number(amountNum) / Number(currentNavNum);
        return "".concat(units.toFixed(2), " / ").concat(currentNavNum.toFixed(2));
    }
    return "-";
};
/**
 * getSidebarView
 *
 * Provides orderbook sidebar view - returns which components to be shown for the given status, transaction type, from which screen the sidebar is opening
 *
 * @param {string} status - Transaction status
 * @param {string} transactionType - Transaction type
 * @param {ESidebarActioningFrom} actionFrom - Screen from which the sidebar is opened
 * @param {EOrderbookSidebarComponents} componentName - Sidebar's component name
 * @returns {}
 */
export var getSidebarView = function (status, transactionType, actionFrom, componentName) {
    var _a;
    var getSidebarConditions = sidebarConditions(actionFrom);
    var schemeDetails = showSchemeDetailsComponent;
    var transactionDetails = showTransactionDetailsComponent;
    var orderTimelineDetails = showOrderTimelineDetailsComponent;
    var pastInstallments = showPastInstallmentsComponent;
    var sidebarComponents = (_a = {},
        _a[EOrderbookSidebarComponents.STATUS_BOX] = true,
        _a[EOrderbookSidebarComponents.SCHEME_DETAILS] = schemeDetails(status, transactionType, getSidebarConditions),
        _a[EOrderbookSidebarComponents.TRANSACTION_DETAILS] = transactionDetails(status, transactionType, getSidebarConditions),
        _a[EOrderbookSidebarComponents.ORDER_TIMELINE_DETAILS] = orderTimelineDetails(status, transactionType, getSidebarConditions),
        _a[EOrderbookSidebarComponents.PAST_INSTALLMENTS] = pastInstallments(status, transactionType, getSidebarConditions),
        _a);
    if (componentName) {
        return sidebarComponents[componentName];
    }
};
// Common method to return sidebar conditions based on the screen from which it is opened
var sidebarConditions = function (actionFrom) {
    switch (actionFrom) {
        case ESidebarActioningFrom.ALL_TRANSACTIONS_TABLE:
            return sidebarConditionForAllTransactionsTable;
        case ESidebarActioningFrom.SIP_TABLE:
            return sidebarConditionForSIPTable;
        case ESidebarActioningFrom.STP_TABLE:
            return sidebarConditionForSTPTable;
        case ESidebarActioningFrom.SWP_TABLE:
            return sidebarConditionForSWPTable;
        default:
            return;
    }
};
// Display sidebar scheme details component when common condition is met
var showSchemeDetailsComponent = function (status, transactionType, getSidebarConditions) {
    if (getSidebarConditions) {
        return getSidebarConditions(status, transactionType);
    }
    return false;
};
// Display sidebar transaction details component when common condition is not met
var showTransactionDetailsComponent = function (status, transactionType, getSidebarConditions) {
    if (getSidebarConditions) {
        return !getSidebarConditions(status, transactionType);
    }
    return false;
};
// Display sidebar order timeline details component when
// - common condition is not met and
// - Status is not CONSENT_PENDING and not CONSENT_REJECTED and when Transaction type is not of SIP installment
var showOrderTimelineDetailsComponent = function (status, transactionType, getSidebarConditions) {
    if (getSidebarConditions) {
        return (!getSidebarConditions(status, transactionType) &&
            status !== EOrderBookStatus.CONSENT_PENDING &&
            status !== EOrderBookStatus.CONSENT_REJECTED &&
            transactionType !== ETransactionType.SIP_INSTALLMENT // trxId is Null for transaction type SIP_INSTALLMENT
        );
    }
    return false;
};
// Display sidebar past installments component when common condition is met
var showPastInstallmentsComponent = function (status, transactionType, getSidebarConditions) {
    if (getSidebarConditions) {
        return getSidebarConditions(status, transactionType);
    }
    return false;
};
// Common condition to display/hide components on sidebar opened from All transations table
var sidebarConditionForAllTransactionsTable = function (status, transactionType) {
    return ((status === EOrderBookStatus.ORDER_COMPLETED ||
        status === EOrderBookStatus.ACTIVE ||
        status === EOrderBookStatus.PAUSE) &&
        (transactionType === ETransactionType.SIP ||
            transactionType === ETransactionType.SIP_INSTALLMENT ||
            transactionType === ETransactionType.SIP_CANCEL ||
            transactionType === ETransactionType.SWP ||
            transactionType === ETransactionType.SWP_INSTALLMENT));
};
// Common condition to display/hide components on sidebar opened from SIP table
var sidebarConditionForSIPTable = function (status) {
    return (status === EOrderBookStatus.ORDER_COMPLETED ||
        status === EOrderBookStatus.ORDER_CANCELLED ||
        status === EOrderBookStatus.ACTIVE ||
        status === EOrderBookStatus.PAUSE);
};
// Common condition to display/hide components on sidebar opened from STP table
var sidebarConditionForSTPTable = function (status) {
    return (status === EOrderBookStatus.ORDER_COMPLETED ||
        status === EOrderBookStatus.ACTIVE ||
        status === EOrderBookStatus.ORDER_CANCELLED);
};
// Common condition to display/hide components on sidebar opened from SWP table
var sidebarConditionForSWPTable = function (status) {
    return (status === EOrderBookStatus.ORDER_COMPLETED ||
        status === EOrderBookStatus.ACTIVE ||
        status === EOrderBookStatus.ORDER_CANCELLED);
};
// *******************************************
// *     Order book footer constants         *
// *******************************************
// Constants for More Details section
var moreDetails = [
    { icon: "edel-icon-cross", text: "Cancel" },
    { icon: "edel-icon-editicon-underline", text: "Modify" },
];
var moreDetailsSIP = [
    { icon: "edel-icon-calendar-cross", text: "Cancel SIP" },
    { icon: "edel-icon-editicon-underline", text: "Modify" },
];
export var moreDetailsCompleted = [
    { icon: "edel-icon-transfer", text: "Start STP" },
    { icon: "edel-icon-calendar-down-arrow\"", text: "Start SWP" },
    { icon: "edel-icon-switch-fund-3", text: "Switch Fund" },
];
export var moreDetailsPaused = __spreadArray(__spreadArray([], __read(moreDetailsCompleted), false), [
    { icon: "edel-icon-withdrawal", text: "Resume" },
], false);
var getFooterDetailsCommon = function (isSIP) {
    var _a;
    if (isSIP === void 0) { isSIP = false; }
    return (_a = {},
        _a[EOrderBookStatus.CONSENT_PENDING] = {
            label: EKebebMenuItems.RESEND_CONSENT_REQUEST,
        },
        _a[EOrderBookStatus.CONSENT_REJECTED] = {
            label: EKebebMenuItems.DUPLICATE,
        },
        _a[EOrderBookStatus.PAYMENT_PENDING] = {
            label: EKebebMenuItems.RESEND_PAYMENT_LINK,
        },
        _a[EOrderBookStatus.PAYMENT_FAILED] = {
            label: EKebebMenuItems.RESEND_PAYMENT_LINK,
        },
        _a[EOrderBookStatus.ORDER_REJECTED] = {
            label: EKebebMenuItems.DUPLICATE,
        },
        _a[EOrderBookStatus.ORDER_CANCELLED] = {
            label: EKebebMenuItems.DUPLICATE,
        },
        _a);
};
export var footerDetails = (_d = {},
    //LUMPSUM
    _d[ETransactionType.LUMPSUM] = __assign(__assign({}, getFooterDetailsCommon()), (_e = {}, _e[EOrderBookStatus.ORDER_COMPLETED] = {
        label: EKebebMenuItems.PLACE_ORDER_AGAIN,
    }, _e)),
    //SIP
    _d[ETransactionType.SIP] = __assign(__assign({}, getFooterDetailsCommon(true)), (_f = {}, _f[EOrderBookStatus.ACTIVE] = {
        label: EKebebMenuItems.PAUSE,
    }, _f[EOrderBookStatus.PAUSE] = {
        label: EKebebMenuItems.RESUME,
    }, _f[EOrderBookStatus.ORDER_COMPLETED] = {
        // if from sip tab show duplicate else
        label: EKebebMenuItems.PLACE_ORDER_AGAIN,
    }, _f)),
    //REDEEM
    _d[ETransactionType.REDEEM] = __assign(__assign({}, getFooterDetailsCommon()), (_g = {}, _g[EOrderBookStatus.ORDER_COMPLETED] = {
        label: EKebebMenuItems.PLACE_ORDER_AGAIN,
    }, _g)),
    //SWP
    _d[ETransactionType.SWP] = __assign(__assign({}, getFooterDetailsCommon()), (_h = {}, _h[EOrderBookStatus.ACTIVE] = { label: EKebebMenuItems.CANCEL }, _h)),
    //STP
    _d[ETransactionType.STP] = __assign(__assign({}, getFooterDetailsCommon()), (_j = {}, _j[EOrderBookStatus.ACTIVE] = {
        label: EKebebMenuItems.CANCEL,
    }, _j)),
    //SWITCH
    _d[ETransactionType.SWITCH] = __assign(__assign({}, getFooterDetailsCommon()), (_k = {}, _k[EOrderBookStatus.ORDER_COMPLETED] = {
        label: EKebebMenuItems.PLACE_ORDER_AGAIN,
    }, _k)),
    // Child transaction types
    _d[ETransactionType.SIP_PAUSE] = (_l = {},
        _l[EOrderBookStatus.CONSENT_PENDING] = {
            label: EKebebMenuItems.RESEND_CONSENT_REQUEST,
        },
        _l),
    _d[ETransactionType.SIP_CANCEL] = (_m = {},
        _m[EOrderBookStatus.CONSENT_PENDING] = {
            label: EKebebMenuItems.RESEND_CONSENT_REQUEST,
        },
        _m),
    _d[ETransactionType.SIP_MODIFY] = (_o = {},
        _o[EOrderBookStatus.CONSENT_PENDING] = {
            label: EKebebMenuItems.RESEND_CONSENT_REQUEST,
        },
        _o),
    _d[ETransactionType.SWP_CANCEL] = (_p = {},
        _p[EOrderBookStatus.CONSENT_PENDING] = {
            label: EKebebMenuItems.RESEND_CONSENT_REQUEST,
        },
        _p),
    _d[ETransactionType.STP_CANCEL] = (_q = {},
        _q[EOrderBookStatus.CONSENT_PENDING] = {
            label: EKebebMenuItems.RESEND_CONSENT_REQUEST,
        },
        _q),
    _d[ETransactionType.SIP_INSTALLMENT] = {},
    _d[ETransactionType.SIP_RESUME] = {},
    _d[ETransactionType.SWP_INSTALLMENT] = {},
    _d[ETransactionType.STP_INSTALLMENT] = {},
    _d);
export var getStatusDescriptionForMandates = function (status) {
    switch (status) {
        case EMandateStatuses.REGISTRATION_PENDING:
            return "Please complete your mandate registration to link it with your SIP.";
        case EMandateStatuses.REGISTRATION_FAILED:
            return "Invalid net banking credentials. Please retry.";
        case EMandateStatuses.PROCESSING:
            return "Your document is under verification.";
        case EMandateStatuses.INACTIVE:
            return "Your account is currently inactive. Reactivate anytime to continue using our mandate services";
        default:
            return undefined;
    }
};
